import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["addDO", "addRG"];

  toggleAddDO() {
    if (event.target.value === "1") {
      this.addDOTarget.classList.remove("d-none");
    } else {
      this.addDOTarget.classList.add("d-none");
    }
  }

  toggleAddRG() {
    if (event.target.value === "1") {
      this.addRGTarget.classList.remove("d-none");
    } else {
      this.addRGTarget.classList.add("d-none");
    }
  }
}
